module.exports = __webpack_public_path__ + "static/img/banner002.bde6ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner002.png
// module id = yWm2
// module chunks = 15